<script setup>
// @ts-check
import { setup } from './useLogout'
import { route } from '@/utils/ziggy.js'

const { showAppHeader, isPc, clickAppHeader, clickDownloadButton } = setup()
</script>

<template>
  <!-- appHeader -->
  <div
    v-if="!isPc"
    class="appHeader pcHide"
    :style="showAppHeader ? {} : { display: 'none' }"
  >
    <button
      class="closeBtn js_closeTrigger"
      @click="clickAppHeader"
    >
      <span class="iconImgPart">
        <svg
          width="8"
          height="8"
          viewBox="0 0 8 8"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M0.646447 0.646447C0.841709 0.451184 1.15829 0.451184 1.35355 0.646447L4 3.29289L6.64645 0.646447C6.84171 0.451184 7.15829 0.451184 7.35355 0.646447C7.54882 0.841709 7.54882 1.15829 7.35355 1.35355L4.70711 4L7.35355 6.64645C7.54882 6.84171 7.54882 7.15829 7.35355 7.35355C7.15829 7.54882 6.84171 7.54882 6.64645 7.35355L4 4.70711L1.35355 7.35355C1.15829 7.54882 0.841709 7.54882 0.646447 7.35355C0.451184 7.15829 0.451184 6.84171 0.646447 6.64645L3.29289 4L0.646447 1.35355C0.451184 1.15829 0.451184 0.841709 0.646447 0.646447Z"
            fill="#747C92"
          />
        </svg>
      </span>
    </button>
    <div class="appIcon">
      <img
        src="/student_site/imageFile/logoutTop/logo_app.png"
        alt=""
      />
    </div>
    <div class="textSet">
      <div class="catch">アイルーツ公式アプリ</div>
      <span class="copy">新卒学生のための就活スカウト</span>
    </div>
    <button
      class="appBtn"
      @click="clickDownloadButton"
    >
      ダウンロード
    </button>
  </div>
  <!-- /appHeader -->

  <div class="container">
    <!-- panel -->
    <section class="panelUnit">
      <div class="panelBgArea">
        <picture>
          <source
            srcset="/student_site/imageFile/logoutTop/panel_pc.webp"
            media="(min-width: 768px)"
            type="image/webp"
            class="panelImg"
          />
          <source
            srcset="/student_site/imageFile/logoutTop/panel_pc.jpg"
            media="(min-width: 768px)"
            class="panelImg"
          />
          <source
            srcset="/student_site/imageFile/logoutTop/panel_sp.webp"
            type="image/webp"
            class="panelImg"
          />
          <img
            src="/student_site/imageFile/logoutTop/panel_sp.jpg"
            alt=""
            class="panelImg"
          />
        </picture>
      </div>

      <!-- header -->
      <header class="logoutHeader">
        <div class="logo">
          <a href="#"
            ><img
              src="/student_site/imageFile/logo_white.svg"
              alt=""
          /></a>
        </div>
        <div class="btnArea">
          <div class="link pcShow">
            <a
              href="https://iroots.jp/html/pr/company/index.html"
              target="_blank"
            >
              採用担当者はこちら
            </a>
          </div>
          <div class="loginBtn">
            <a :href="route('student.login.form')">ログイン</a>
          </div>
        </div>
      </header>
      <!-- /header -->

      <div class="panelTextArea">
        <div class="baloon">審査通過率<span class="num">10</span>%</div>
        <h1 class="catch">
          <div class="row"><span class="company">厳選企業</span><span class="from">から</span></div>
          <div class="row"><span class="scout">スカウトが届く！</span></div>
        </h1>
        <p class="copy">アイルーツ独自の特別選考スカウトも！</p>
      </div>

      <div class="companyArea">
        <div class="title">現在掲載中の企業</div>
        <div class="logoSet">
          <picture>
            <source
              srcset="/student_site/imageFile/logoutTop/companies_logo_pc.jpg"
              media="(min-width: 768px)"
              type="image/jpg"
            />
            <img
              src="/student_site/imageFile/logoutTop/companies_logo_sp.jpg"
              alt=""
            />
          </picture>
        </div>
        <div class="submitBtnSet">
          <a
            :href="route('student.signup.form')"
            class="md_btn md_btn--submit"
            >厳選企業からスカウトを受け取る</a
          >
        </div>
        <div class="appBtnSet pcHide">
          <a href="https://play.google.com/store/apps/details?id=com.en_japan.iroots&pcampaignid=web_share"
            ><img
              alt="Google Play で手に入れよう"
              src="/student_site/imageFile/logoutTop/google_play_badge.svg"
              height="42px"
          /></a>
          <a
            href="https://apps.apple.com/jp/app/%E5%B0%B1%E6%B4%BB-%E3%81%AA%E3%82%89iroots-%E5%B0%B1%E6%B4%BB%E3%82%B5%E3%82%A4%E3%83%88%E3%81%AE%E5%B0%B1%E6%B4%BB%E3%82%A2%E3%83%97%E3%83%AA-%E3%82%B9%E3%82%AB%E3%82%A6%E3%83%88/id1479541565?itscg=30200&itsct=apps_box_badge&mttnsubad=1479541565"
            style="display: inline-block"
            ><img
              src="https://toolbox.marketingtools.apple.com/api/v2/badges/download-on-the-app-store/black/ja-jp?releaseDate=1579737600"
              alt="App Storeでダウンロード"
              style="height: 42px; vertical-align: middle; object-fit: contain"
          /></a>
        </div>
      </div>
    </section>
    <!-- /panel -->

    <!-- about -->
    <section class="contentUnit">
      <div class="inner">
        <div class="aboutArea">
          <div class="imageSection">
            <h2 class="titleCell">
              <div class="title">アイルーツとは</div>
              <div class="subTitle">
                <span class="highlights">市場価値が高まる企業</span>と出会える<br />スカウト型サービス
              </div>
            </h2>
            <div class="imageCell">
              <img
                src="/student_site/imageFile/logoutTop/about.png"
                alt=""
              />
            </div>
          </div>
          <ul class="pointList">
            <li class="point">
              <div class="pointCell">
                <span class="label">POINT</span>
                <span class="num">01</span>
              </div>
              <div class="textCell">
                <div class="text">利用企業は<span class="marker">完全審査制</span>！</div>
                <span class="sub">※ 審査通過率10％</span>
              </div>
            </li>
            <li class="point">
              <div class="pointCell">
                <span class="label">POINT</span>
                <span class="num">02</span>
              </div>
              <div class="textCell">
                <div class="text">
                  会員限定のイベント招待や<br />
                  特別選考の<span class="marker">優遇あり</span>！
                </div>
              </div>
            </li>
            <li class="point">
              <div class="pointCell">
                <span class="label">POINT</span>
                <span class="num">03</span>
              </div>
              <div class="textCell">
                <div class="text">
                  スカウトリクエストで<br />
                  人気企業に<span class="marker">アプローチ可能</span>！
                </div>
              </div>
            </li>
            <li class="point">
              <div class="pointCell">
                <span class="label">POINT</span>
                <span class="num">04</span>
              </div>
              <div class="textCell">
                <div class="text">
                  企業に直接エントリーできる<br />
                  <span class="marker">特別求人もあり</span>！
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </section>
    <!-- /about -->

    <!-- btnUnit -->
    <div class="btnUnit">
      <div class="inner">
        <div class="submitBtnSet">
          <a
            :href="route('student.signup.form')"
            class="md_btn md_btn--submit"
            >厳選企業からスカウトを受け取る</a
          >
        </div>
        <div class="appBtnSet pcHide">
          <a href="https://play.google.com/store/apps/details?id=com.en_japan.iroots&pcampaignid=web_share"
            ><img
              alt="Google Play で手に入れよう"
              src="/student_site/imageFile/logoutTop/google_play_badge.svg"
              height="42px"
          /></a>
          <a
            href="https://apps.apple.com/jp/app/%E5%B0%B1%E6%B4%BB-%E3%81%AA%E3%82%89iroots-%E5%B0%B1%E6%B4%BB%E3%82%B5%E3%82%A4%E3%83%88%E3%81%AE%E5%B0%B1%E6%B4%BB%E3%82%A2%E3%83%97%E3%83%AA-%E3%82%B9%E3%82%AB%E3%82%A6%E3%83%88/id1479541565?itscg=30200&itsct=apps_box_badge&mttnsubad=1479541565"
            style="display: inline-block"
            ><img
              src="https://toolbox.marketingtools.apple.com/api/v2/badges/download-on-the-app-store/black/ja-jp?releaseDate=1579737600"
              alt="App Storeでダウンロード"
              style="height: 42px; vertical-align: middle; object-fit: contain"
          /></a>
        </div>
      </div>
    </div>
    <!-- /btnUnit -->

    <!-- what -->
    <section class="contentUnit contentUnit--white">
      <div class="inner">
        <div class="contentTitle">
          <span class="sub">WHAT</span>
          <h2 class="title">アイルーツが<br class="pcHide" />選ばれる理由</h2>
        </div>
        <div class="whatArea">
          <div class="whatSet">
            <div class="layoutWrap">
              <div class="titleCell">
                <h3 class="subTitle">
                  厳しい審査を通過した<br />
                  優良企業からスカウトが届く
                </h3>
              </div>
              <div class="imageCell">
                <img
                  src="/student_site/imageFile/logoutTop/what01.png"
                  alt=""
                />
              </div>
              <div class="textCell">
                <p class="text">
                  「会社の成長性・将来性」「20代の成長環境」「クチコミによる評判」をもとに、​利用企業をすべて審査（審査通過率は10%）。市場価値が高まる大手企業やベンチャー企業からスカウトが届きます。
                </p>
              </div>
            </div>
            <div class="btnCell">
              <a
                :href="route('student.signup.form')"
                class="md_btn md_btn--submit"
                >厳選企業からスカウトを受け取る</a
              >
            </div>
          </div>
          <div class="whatSet">
            <div class="layoutWrap layoutWrap--reverse">
              <div class="titleCell">
                <h3 class="subTitle">
                  アイルーツ限定！<br />
                  特別選考スカウトが届く
                </h3>
              </div>
              <div class="imageCell">
                <img
                  src="/student_site/imageFile/logoutTop/what02.png"
                  alt=""
                />
              </div>
              <div class="textCell">
                <p class="text">
                  『ES免除』『選抜型インターンの参加確約』『入社後の配属確約』など、アイルーツ会員限定の特別選考スカウトも届きます。
                </p>
              </div>
            </div>
            <div class="btnCell">
              <a
                :href="route('student.signup.form')"
                class="md_btn md_btn--submit"
                >特別選考スカウトを受け取る</a
              >
            </div>
          </div>
          <div class="whatSet">
            <div class="layoutWrap">
              <div class="titleCell">
                <h3 class="subTitle">
                  スカウトリクエストで<br />
                  気になる企業にアプローチできる
                </h3>
              </div>
              <div class="imageCell">
                <img
                  src="/student_site/imageFile/logoutTop/what03.png"
                  alt=""
                />
              </div>
              <div class="textCell">
                <p class="text">
                  あなたから、気になる企業にスカウトリクエストが可能です。この機能を使うことで、企業からスカウトが届く可能性が約3倍にアップします。
                </p>
              </div>
            </div>
            <!-- 2次対応でスカウトリクエスト部分が実装されたら削除 -->
            <div class="btnCell">
              <a
                :href="route('student.signup.form')"
                class="md_btn md_btn--submit"
                >スカウトリクエストする</a
              >
            </div>
            <!-- /2次対応でスカウトリクエスト部分が実装されたら削除 -->
          </div>
          <div class="whatSet">
            <div class="layoutWrap layoutWrap--reverse">
              <div class="titleCell">
                <h3 class="subTitle">
                  気になる企業の募集に<br />
                  直接エントリーできる
                </h3>
              </div>
              <div class="imageCell">
                <img
                  src="/student_site/imageFile/logoutTop/what04.png"
                  alt=""
                />
              </div>
              <div class="textCell">
                <p class="text">
                  開催中のインターンシップや説明会、選考に直接エントリーできます。<br />
                  特別求人を出している企業、多数掲載中です！
                </p>
              </div>
            </div>
            <div class="btnCell">
              <a
                :href="route('student.signup.form')"
                class="md_btn md_btn--submit"
                >直接エントリーする</a
              >
            </div>
          </div>
        </div>
      </div>
      <div class="andmore">
        <div class="inner">
          <div class="whatArea">
            <div class="more">
              <span class="iconImgPart"
                ><svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M11.3431 5.34307H6.65693V0.65693C6.65693 0.306598 6.35032 0 6 0C5.64968 0 5.34307 0.306609 5.34307 0.65693V5.34307H0.65693C0.306598 5.34307 0 5.64968 0 6C0 6.35032 0.306609 6.65693 0.65693 6.65693H5.34307V11.3431C5.34307 11.6934 5.64968 12 6 12C6.35032 12 6.65693 11.6934 6.65693 11.3431V6.65693H11.3431C11.6934 6.65693 12 6.35032 12 6C12 5.64968 11.6934 5.34307 11.3431 5.34307Z"
                    fill="#747C92"
                  />
                </svg>
              </span>
              <div class="copy">さらに、選ばれる理由として…</div>
            </div>
            <div class="whatSet">
              <div class="layoutWrap">
                <div class="titleCell">
                  <h3 class="subTitle">
                    適性診断が<br />
                    自己分析やES作成に役立ちます
                  </h3>
                </div>
                <div class="imageCell">
                  <img
                    src="/student_site/imageFile/logoutTop/what05.png"
                    alt=""
                  />
                </div>
                <div class="textCell">
                  <p class="text">
                    15分の適性診断で、自分の性格や価値観を可視化できます。強みや弱み、キャリアタイプ、活躍しやすい仕事を知ることができるので、自己分析やES作成で役立ちます。
                  </p>
                </div>
              </div>
              <div class="btnCell">
                <a
                  :href="route('student.signup.form')"
                  class="md_btn md_btn--submit"
                  >適性診断を使う</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- /what -->

    <!-- voice -->
    <section class="contentUnit contentUnit--white">
      <div class="inner">
        <div class="contentTitle">
          <span class="sub">VOICE</span>
          <h2 class="title">アイルーツを利用している<br />先輩の声</h2>
        </div>
        <div class="voiceArea">
          <div class="chartCard">
            <div class="baloonSet">
              <span class="sub">アイルーツ利用中の先輩に聞いた</span>
              <p class="catch">なぜアイルーツを利用していますか？</p>
            </div>
            <div class="chartSet">
              <div class="chartCell">
                <img
                  src="/student_site/imageFile/logoutTop/voice_chart.png"
                  alt="31.5%:優良企業からスカウトが届く/26.2%:ES免状等のスカウト特典がある/18:0%:適性診断を利用できる/10:9%:スカウトリクエストを送れる"
                />
              </div>
              <div class="dataCell">
                <div class="otherData">
                  <ul class="row">
                    <li class="item">7.9%</li>
                    <li class="data">プロフィールを最大6,000字書ける</li>
                  </ul>
                  <ul class="row">
                    <li class="item">3.4%</li>
                    <li class="data">先輩の就職体験記を読める</li>
                  </ul>
                  <ul class="row">
                    <li class="item">2.2%</li>
                    <li class="data">その他</li>
                  </ul>
                </div>
                <p class="notes">※2024年8月　自社アンケート調査実施（N-89）</p>
              </div>
            </div>
          </div>
          <div class="userVoice">
            <div class="titleSet">
              <h3 class="title">スカウトに関する声</h3>
            </div>
            <div class="voiceWrap">
              <div class="voiceCard voiceCard--blue voiceCard--reverse">
                <div class="textSection">
                  <h4 class="title">スカウトによって就活の幅が広がった</h4>
                  <p class="comment">
                    irootsは厳選した企業からスカウトが届くため、その瞬間に興味を持っていなくてもなるべくスカウトを受諾しお話を聞くようにしていました。
                    そこで自分が思っていたよりも興味の幅が広いことが分かり、少しずつ就活の幅が広がりました。
                    最終的に選んだ企業は、当初の想像とは大きく異なった企業になりましたが、人として視野が広がった上で決断できたため、より良い選択ができたと信じています。
                  </p>
                </div>
                <div class="userSection">
                  <div class="icon">
                    <img
                      src="/student_site/imageFile/logoutTop/user_m_01.svg"
                      alt="横浜国立大学/理系/男性"
                    />
                  </div>
                  <div class="data">横浜国立大学&thinsp;/&thinsp;理系&thinsp;/&thinsp;男性</div>
                </div>
              </div>
              <div class="voiceCard voiceCard--red">
                <div class="textSection">
                  <h4 class="title">たくさんのスカウトをいただけた</h4>
                  <p class="comment">
                    irootsを利用してたくさんのスカウトをいただくことが出来ました。就活を始めた時期が人より遅い中、エントリーシートや面接の練習を沢山することができ、無事に内定をいただくことが出来たのが良かったです。
                  </p>
                </div>
                <div class="userSection">
                  <div class="icon">
                    <img
                      src="/student_site/imageFile/logoutTop/user_f_01.svg"
                      alt="滋賀大学/文系/女性"
                    />
                  </div>
                  <div class="data">滋賀大学&thinsp;/&thinsp;文系&thinsp;/&thinsp;女性</div>
                </div>
              </div>
              <div class="voiceCard voiceCard--blue voiceCard--reverse">
                <div class="textSection">
                  <h4 class="title">自身とマッチした企業からのスカウトが多かった</h4>
                  <p class="comment">
                    価値観を定量化し、その価値観をもとにスカウトが来たので、自信と非常にマッチした企業からのスカウトが多かったと感じました。
                  </p>
                </div>
                <div class="userSection">
                  <div class="icon">
                    <img
                      src="/student_site/imageFile/logoutTop/user_m_02.svg"
                      alt="法政大学/文系/男性"
                    />
                  </div>
                  <div class="data">法政大学&thinsp;/&thinsp;文系&thinsp;/&thinsp;男性</div>
                </div>
              </div>
            </div>
          </div>
          <div class="userVoice">
            <div class="titleSet">
              <h3 class="title">スカウトリクエストに関する声</h3>
            </div>
            <div class="voiceWrap">
              <div class="voiceCard voiceCard--blue">
                <div class="textSection">
                  <h4 class="title">スカウトリクエストを送ることができ、モチベーションにつながった</h4>
                  <p class="comment">
                    スカウトが送られてくる企業がどれも魅力的であり、選考の方針も事前に明確でわかりやすかったです。また、気になる企業に対して、自分からスカウトリクエストを送ることができる点もモチベーションにつながりました。
                  </p>
                </div>
                <div class="userSection">
                  <div class="icon">
                    <img
                      src="/student_site/imageFile/logoutTop/user_m_03.svg"
                      alt="立教大学/文系/男性"
                    />
                  </div>
                  <div class="data">立教大学&thinsp;/&thinsp;文系&thinsp;/&thinsp;男性</div>
                </div>
              </div>
              <div class="voiceCard voiceCard--red voiceCard--reverse">
                <div class="textSection">
                  <h4 class="title">スカウトリクエストによってガクチカに磨きがかかった</h4>
                  <p class="comment">
                    気になる企業にスカウトリクエストを送れるため、想いを綴ってリクエストを送信したり、どうしたら良い結果を得られるか、登録したプロフィールやガクチカなどの改良など、日々考えて改善ができました。結果として、自身のガクチカなどにも磨きがかかり、就活をスムーズに進めることができました。
                  </p>
                </div>
                <div class="userSection">
                  <div class="icon">
                    <img
                      src="/student_site/imageFile/logoutTop/user_f_02.svg"
                      alt="慶応義塾大学/文系/女性"
                    />
                  </div>
                  <div class="data">慶応義塾大学&thinsp;/&thinsp;文系&thinsp;/&thinsp;女性</div>
                </div>
              </div>
            </div>
          </div>
          <div class="userVoice">
            <div class="titleSet">
              <h3 class="title">適性診断に関する声</h3>
            </div>
            <div class="voiceWrap">
              <div class="voiceCard voiceCard--blue">
                <div class="textSection">
                  <h4 class="title">自分のやりたい仕事が何かを掴むきっかけになった</h4>
                  <p class="comment">
                    自己診断ツールが良かったです。このツールを用いて自己分析を進め、自分が何者なのか、自分のやりたい仕事は何かを掴むきっかけになりました。
                  </p>
                </div>
                <div class="userSection">
                  <div class="icon">
                    <img
                      src="/student_site/imageFile/logoutTop/user_m_04.svg"
                      alt="早稲田大学/文系/男性"
                    />
                  </div>
                  <div class="data">早稲田大学&thinsp;/&thinsp;文系&thinsp;/&thinsp;男性</div>
                </div>
              </div>
              <div class="voiceCard voiceCard--red voiceCard--reverse">
                <div class="textSection">
                  <div class="title">面接でのアピールに自信を持てた</div>
                  <p class="comment">
                    自己分析を通して、自分の性格や考え方、強みなどを自覚することができました。その結果、自己PRやガクチカなど、面接でのアピールに自信を持って望むことができました。
                  </p>
                </div>
                <div class="userSection">
                  <div class="icon">
                    <img
                      src="/student_site/imageFile/logoutTop/user_f_03.svg"
                      alt="静岡大学大学院/理系/女性"
                    />
                  </div>
                  <div class="data">静岡大学大学院&thinsp;/&thinsp;理系&thinsp;/&thinsp;女性</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- /voice -->

    <!-- btnUnit -->
    <div class="btnUnit">
      <div class="inner">
        <div class="submitBtnSet">
          <a
            :href="route('student.signup.form')"
            class="md_btn md_btn--submit"
            >厳選企業からスカウトを受け取る</a
          >
        </div>
        <div class="appBtnSet pcHide">
          <a href="https://play.google.com/store/apps/details?id=com.en_japan.iroots&pcampaignid=web_share"
            ><img
              alt="Google Play で手に入れよう"
              src="/student_site/imageFile/logoutTop/google_play_badge.svg"
              height="42px"
          /></a>
          <a
            href="https://apps.apple.com/jp/app/%E5%B0%B1%E6%B4%BB-%E3%81%AA%E3%82%89iroots-%E5%B0%B1%E6%B4%BB%E3%82%B5%E3%82%A4%E3%83%88%E3%81%AE%E5%B0%B1%E6%B4%BB%E3%82%A2%E3%83%97%E3%83%AA-%E3%82%B9%E3%82%AB%E3%82%A6%E3%83%88/id1479541565?itscg=30200&itsct=apps_box_badge&mttnsubad=1479541565"
            style="display: inline-block"
            ><img
              src="https://toolbox.marketingtools.apple.com/api/v2/badges/download-on-the-app-store/black/ja-jp?releaseDate=1579737600"
              alt="App Storeでダウンロード"
              style="height: 42px; vertical-align: middle; object-fit: contain"
          /></a>
        </div>
      </div>
    </div>
    <!-- /btnUnit -->

    <!-- thoughts -->
    <section class="contentUnit contentUnit--grad">
      <div class="inner">
        <div class="contentTitle contentTitle--white">
          <div class="sub">THOUGHTS</div>
          <h2 class="title">アイルーツに込めた想い</h2>
        </div>
        <div class="thoughtsArea">
          <p class="text">
            「この企業に入っておけば安心」という常識は変わりつつあり、一方で私たち一人ひとりは70歳まで働く時代に突入しています。<br /><br />
            転職や副業、起業、フリーランスなど、自分の働き方やキャリアの選択肢が広がる時代に、ファーストキャリアで必要なことは「どこでも通用する力」を身につけることではないでしょうか。<br /><br />
            たとえいかなる事情や環境に置かれても、自分のやりたいことが変わっても、「どこでも通用する力」があれば、キャリアを自分の意志で選べるようになります。<br /><br />
            アイルーツは、本当に若手の成長環境が揃った企業だけからスカウトが届くよう、審査通過率を約10％と厳しく設定しました。<br /><br />
            皆さんが入社後に活躍し、市場価値を高め、「どこでも通用する力」を身につけることを願っています。
          </p>
          <div class="btanSet">
            <a
              :href="route('student.signup.form')"
              class="md_btn md_btn--submit"
              >無料登録してアイルーツを使う</a
            >
          </div>
        </div>
      </div>
    </section>
    <!-- /thoughts -->

    <!-- btnUnit -->
    <div class="btnUnit btnUnit--app">
      <div class="inner">
        <div class="textSet">
          <div class="appIcon">
            <img
              src="/student_site/imageFile/logoutTop/logo_app.png"
              alt=""
            />
          </div>
          <div class="textCell">
            <div class="catch">アイルーツ公式アプリ</div>
            <span class="copy">新卒学生のための就活スカウト</span>
          </div>
        </div>
        <div class="appBtnSet">
          <a href="https://play.google.com/store/apps/details?id=com.en_japan.iroots&pcampaignid=web_share"
            ><img
              alt="Google Play で手に入れよう"
              src="/student_site/imageFile/logoutTop/google_play_badge.svg"
              height="46px"
          /></a>
          <a
            href="https://apps.apple.com/jp/app/%E5%B0%B1%E6%B4%BB-%E3%81%AA%E3%82%89iroots-%E5%B0%B1%E6%B4%BB%E3%82%B5%E3%82%A4%E3%83%88%E3%81%AE%E5%B0%B1%E6%B4%BB%E3%82%A2%E3%83%97%E3%83%AA-%E3%82%B9%E3%82%AB%E3%82%A6%E3%83%88/id1479541565?itscg=30200&itsct=apps_box_badge&mttnsubad=1479541565"
            style="display: inline-block"
            ><img
              src="https://toolbox.marketingtools.apple.com/api/v2/badges/download-on-the-app-store/black/ja-jp?releaseDate=1579737600"
              alt="App Storeでダウンロード"
              style="height: 46px; vertical-align: middle; object-fit: contain"
          /></a>
        </div>
      </div>
    </div>
    <!-- /btnUnit -->
  </div>
</template>
